import { InputDate } from "./input-date";
import { OralDate } from "./oral-date";
export class Dates {
    constructor() {
        this.sessionDate = new InputDate($("#exam_date"));
        this.enrollmentDeadline = new InputDate($("#enrollment_deadline"));
        this.oralDate = new OralDate(this.enrollmentDeadline);
    }
    get correct() {
        if (this.sessionDate === undefined ||
            this.enrollmentDeadline === undefined) {
            return false;
        }
        if (this.sessionDate.isChanged &&
            this.sessionDate.getDaysDifference(new Date()) < 24) {
            throw new Error(incorrectExamDate);
        }
        if (this.enrollmentDeadline.isChanged &&
            this.sessionDate.getDaysDifference(this.enrollmentDeadline) < 24) {
            throw new Error(incorrectDeadline);
        }
        this.oralDate.check();
        return true;
    }
}
